import React from 'react';

interface GeneratingOverlayProps {
    show?: boolean;
}

const GeneratingOverlay: React.FC<GeneratingOverlayProps> = ({ show }) => {
    if (!show) return null;
    return (
        <div className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm flex flex-col items-center justify-center gap-3">
            <div className="animate-spin h-10 w-10 border-4 border-amber-400 border-t-transparent rounded-full" />
            <span className="text-sm text-slate-200 font-medium">AI 生成中...</span>
        </div>
    );
};

export default GeneratingOverlay;
